package com.havn.app.core.settings

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class HavnKioskSecurityRepository(
    initialPin: String = loadStoredHavnKioskPin() ?: DefaultKioskPin
) {
    private val _pin = MutableStateFlow(initialPin)
    val pin: StateFlow<String> = _pin.asStateFlow()

    fun setPin(pin: String) {
        val sanitized = pin.filter { it.isDigit() }.take(8).ifBlank { DefaultKioskPin }
        _pin.value = sanitized
        storeHavnKioskPin(sanitized)
    }

    companion object {
        const val DefaultKioskPin = "1234"
    }
}

expect fun loadStoredHavnKioskPin(): String?

expect fun storeHavnKioskPin(pin: String)
